import { ColorEnum } from '@/constants/color'
import { selectedNameColor } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/constants'
import { useAnimatedTextColorStyle } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/hooks/useAnimatedTextColorStyle'
import { Color } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/types'
import AnimatedTypography from '@/features/ui/typography/animated'
import { FC } from 'react'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface NameProps {
    children: string
    selected: boolean
    disabled?: boolean
    color: Color
}

const Name: FC<NameProps> = ({ children, selected, disabled, color }) => {
    const { styles } = useStyles(stylesheet, { disabled })

    const animatedTextColor = useAnimatedTextColorStyle(selected, {
        unselected: ColorEnum.Black,
        selected: selectedNameColor[color],
    })

    return (
        <AnimatedTypography.Heading
            variant="h4"
            numberOfLines={1}
            style={[styles.name, !disabled && animatedTextColor]}
        >
            {children}
        </AnimatedTypography.Heading>
    )
}

const stylesheet = createStyleSheet({
    name: {
        userSelect: 'none',
        variants: {
            disabled: {
                true: {
                    color: ColorEnum.GRAY_600,
                },
            },
        },
    },
})

export default Name
